import React, { useState, useEffect, useContext } from 'react';
import { fetchActiveDuties } from '../utils/api';
import { UserDataContext } from '../context/UserContext';
import './ListView.css';

function ActiveDutiesListView({ onLogout, onNavigateDuties, onNavigateToMissions }) {
    const { user } = useContext(UserDataContext);
    const username = user?.name || '';
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        loadActiveDuties();
    }, []);

    const loadActiveDuties = async () => {
        try {
            setLoading(true);
            setError('');

            const response = await fetchActiveDuties();

            // Handle different response structures safely
            let duties = [];
            if (response?.data && Array.isArray(response.data)) {
                duties = response.data;
            } else if (response?.duties?.data && Array.isArray(response.duties.data)) {
                duties = response.duties.data;
            } else if (Array.isArray(response)) {
                duties = response;
            }

            setItems(duties);

        } catch (err) {
            setError(err.message || 'Failed to load active duties. Please try again.');
            console.error('Error loading active duties:', err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="list-view-container">
            <header className="list-header">
                <div className="header-content">
                    <h1 className="list-title">Active Duties View</h1>
                    <div className="user-info">
                        {onNavigateDuties && (
                            <button
                                onClick={onNavigateDuties}
                                className="nav-button"
                            >
                                All Duties
                            </button>
                        )}
                        {onNavigateToMissions && (
                            <button
                                onClick={onNavigateToMissions}
                                className="nav-button"
                            >
                                Missions
                            </button>
                        )}
                        <span className="welcome-text">Welcome, {username}!</span>
                        <button onClick={onLogout} className="logout-button">
                            Logout
                        </button>
                    </div>
                </div>
            </header>

            <div className="list-content">
                <div className="list-stats">
                    <span className="stat-item">Total Active Duties: {items.length}</span>
                </div>

                {error && (
                    <div className="error-message">
                        {error}
                        <button onClick={loadActiveDuties} className="retry-button">
                            Retry
                        </button>
                    </div>
                )}

                <div className="table-container">
                    {loading ? (
                        <div className="loading-state">
                            <p>Loading active duties...</p>
                        </div>
                    ) : items.length === 0 ? (
                        <div className="empty-state">
                            <p>No active duties available.</p>
                        </div>
                    ) : (
                        <table>
                            <thead>
                                <tr>
                                    <th>Duty ID</th>
                                    <th>Collector Name</th>
                                    <th>City</th>
                                    <th>DsId</th>
                                    <th>Start Time</th>
                                    <th>Stop Time</th>
                                    <th>Duty Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {items.map((item) => (
                                    <tr key={item.id || item._id || item.dutyId} className="table-row">
                                        <td>{item.dutyId || item.id || '-'}</td>
                                        <td>{item.name || item.collector?.name || item.mission_duty?.collector?.name || '-'}</td>
                                        <td>{item.city || item.collector?.city || item.mission_duty?.collector?.city || '-'}</td>
                                        <td>{item.dsid || item.collector?.dsid || item.mission_duty?.collector?.dsid || '-'}</td>
                                        <td>{item.start_time || item.mission_duty?.start_time ? new Date(item.start_time || item.mission_duty.start_time).toLocaleString() : '-'}</td>
                                        <td>{item.stop_time || item.mission_duty?.stop_time ? new Date(item.stop_time || item.mission_duty.stop_time).toLocaleString() : '-'}</td>
                                        <td>
                                            {item.stop_time ? <span className="status-badge status-completed">
                                                Completed
                                            </span> : <span className="status-badge status-active">
                                                Active
                                            </span>}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
            </div>
        </div>
    );
}

export default ActiveDutiesListView;
